import React from 'react';
import { InfoCard } from '@backstage/core-components';
import { useGithubLoggedIn } from '../hooks/useGithubLoggedIn.esm.js';
import { GithubNotAuthorized } from './GitHubNotAuthorized.esm.js';

const GitHubAuthorizationWrapper = ({
  children,
  title,
  hostname,
  scopes
}) => {
  const { isLoggedIn, addLoginStatus } = useGithubLoggedIn(hostname, scopes);
  return isLoggedIn ? children : /* @__PURE__ */ React.createElement(InfoCard, { title }, /* @__PURE__ */ React.createElement(
    GithubNotAuthorized,
    {
      addLoginStatus,
      hostname
    }
  ));
};

export { GitHubAuthorizationWrapper };
//# sourceMappingURL=GitHubAuthorizationWrapper.esm.js.map
